import { ChangeDetectionStrategy,Component, inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormsModule, NgForm } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export type UpdateSubscriptionProjectExpirationsDialogData = {
    photobookCleanupDelayInDays?: number;
    giftingCleanupDelayInDays?: number;
    printCleanupDelayInDays?: number;
    giftingNotificationDelayInDays?: number;
    photobookNotificationDelayInDays?: number;
    printNotificationDelayInDays?: number;
}

export type UpdateSubscriptionProjectExpirationsDialogResult = {
    photobookCleanupDelayInDays?: number;
    giftingCleanupDelayInDays?: number;
    printCleanupDelayInDays?: number;
    giftingNotificationDelayInDays?: number;
    photobookNotificationDelayInDays?: number;
    printNotificationDelayInDays?: number;
}

@Component({
    templateUrl: 'update-subscription-project-expirations-dialog.component.html',
    styleUrls: ['update-subscription-project-expirations-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDividerModule, MatDialogContent, FormsModule, MatFormField, MatLabel, MatError, MatInput, MatDialogActions, MatButton, MatDialogClose]
})
export class UpdateSubscriptionProjectExpirationsDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<UpdateSubscriptionProjectExpirationsDialogComponent, UpdateSubscriptionProjectExpirationsDialogResult>>(MatDialogRef);
    data = inject<UpdateSubscriptionProjectExpirationsDialogData>(MAT_DIALOG_DATA);
    result: UpdateSubscriptionProjectExpirationsDialogResult;

    @ViewChild('form', { static: false })
    form: NgForm;

    ngOnInit(): void {
        this.result = {
            ...this.data,
        };
        this.addValidators()
    }

    private addValidators() {
        setTimeout(() => {
            const fieldPairs = [
                { cleanupDelay: 'photobookCleanupDelay', notificationDelay: 'photobookNotificationDelay' },
                { cleanupDelay: 'giftingCleanupDelay', notificationDelay: 'giftingNotificationDelay' },
                { cleanupDelay: 'printCleanupDelay', notificationDelay: 'printNotificationDelay' }
            ];

            fieldPairs.forEach(fieldPair => {
                if (this.form.controls[fieldPair.notificationDelay]) {
                    this.form.controls[fieldPair.notificationDelay].clearValidators();
                    this.form.controls[fieldPair.notificationDelay].addValidators([
                        (control: AbstractControl) => {
                           if (!control.value)
                                return null;

                            let cleanupDelay = this.form.controls[fieldPair.cleanupDelay].value;
                            if (!cleanupDelay)
                                return { ['valueNotNull']: true };

                            if (control.value > cleanupDelay)
                                return { ['valueInvalid']: true };

                            return null;
                        }
                    ]);
                }
            });
        });
    }

    editSubscription() {
        this.dialogRef.close(this.result);
    }
}
